export const api = getApiUrl();

function getApiUrl() {
    var host = window.location.hostname;
    switch (host.toLowerCase()) {
        case "localhost":
            return "http://malibaaraapidemo-env.eba-mtm8vptv.eu-west-3.elasticbeanstalk.com";
            //return "https://localhost:44316";

        case "malibaara-demo.s3-website.eu-west-3.amazonaws.com":
            return "http://malibaaraapidemo-env.eba-mtm8vptv.eu-west-3.elasticbeanstalk.com";

        case "malibaara-001-site1.htempurl.com":
            return "http://malibaara-001-site2.htempurl.com";

        case "malibaara.com":
            return "https://malibaara-services.com";
    }
}